/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-wrapper-object-types */
import { generalFunction } from "./logInvocation";
import { METHOD_METADATA_KEY, MethodMetadata } from "./methodMetadata";
import { ProjectorFn } from "./projectorFn";

/**
 * Configures the logger's method metadata to use the given function when projecting the value to the log as context.
 */
export function ProjectReturnAs<TIn = unknown, TOut = TIn>(project: ProjectorFn<TIn, TOut>): MethodDecorator
{
    return logReturnAsFn as MethodDecorator;

    function logReturnAsFn(target: Object, _key: string | symbol, descriptor: TypedPropertyDescriptor<generalFunction>): TypedPropertyDescriptor<generalFunction> | void
    {
        const methodName = descriptor.value.name;
        const methodMetadata: MethodMetadata = Reflect.getOwnMetadata(METHOD_METADATA_KEY, target, methodName) || {};

        methodMetadata.project = project;

        Reflect.defineMetadata(METHOD_METADATA_KEY, methodMetadata, target, methodName);

        return descriptor;
    }
}
